import { ParamHolderElement } from '../../slateTypes';

function paramHolderSerializer(paramElement: ParamHolderElement) {
  const { type, label } = paramElement;
  return `{{#${type}}}${encodeURIComponent(label)}{{/${type}}}`;
}

export default paramHolderSerializer;
